import type { Dialog } from '@common/types'
import { stringify as stringifyQs } from 'qs'
import urlJoin from 'url-join'

export const channelSection = '/channels/'

export type ChannelListUrlDialog = 'cancel' | 'new'

export type ChannelListUrlQueryParams = Dialog<ChannelListUrlDialog>

export const channelListUrl = (params?: ChannelListUrlQueryParams): string => {
  if (params === undefined) {
    return channelSection
  }

  return urlJoin(channelSection, '?' + stringifyQs(params))
}

export const channelDetailPath = ':id'

export type ChannelDetailTab = 'automation' | 'configuration' | 'templates'

export type ChannelDetailUrlQueryParams = Partial<{ tab: ChannelDetailTab }>

export const channelDetailUrl = (id: string, params?: ChannelDetailUrlQueryParams): string => {
  const path = urlJoin(channelSection, encodeURIComponent(id))

  if (params === undefined) {
    return path
  }

  return path + '?' + stringifyQs(params)
}
